import script from "./PivotTableWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./PivotTableWidget.vue?vue&type=script&setup=true&lang=js"

import "./PivotTableWidget.vue?vue&type=style&index=0&id=e1fc3524&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1fc3524"]])

export default __exports__